import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import { inject, observer } from "mobx-react"; // eslint-disable-line

const Progress = (props) => {
  const [glow, setGlow] = useState("");

  const { raised } = props.gcxStore;
  // useEffect(() => {
  //   setGlow("glow");

  //   // setTimeout(() => {
  //   //   setGlow("");
  //   // }, 4000);
  // }, [raised]);
  return (
    <div className="gcx-overlay_progressBar">
      <div
        className={"gcx-overlay_progressBar_inner " + glow}
        style={{
          width: `
           ${props.progress}%
         `,
        }}
      ></div>
      <div className="raised">
        $
        <CountUp
          end={props.raised}
          duration={1}
          separator=","
          decimals={props.raised - Math.floor(props.raised) !== 0 ? 2 : 0}
          preserveValue={true}
          useEasing={false}
        />
      </div>
      <div className="goal">${props.goal}</div>
    </div>
  );
};

export default inject("gcxStore")(observer(Progress));
